import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerCustomScriptsService,
  ProviderCustomScriptsRequestError,
} from '@/services/provider/custom-scripts.service';
import type {
  ProviderCustomScriptsSettings,
  UpdateProviderCustomScriptsInput,
} from '@/types/provider-custom-scripts';

export const providerCustomScriptsKeys = {
  all: ['provider', 'custom-scripts'] as const,
  detail: () => [...providerCustomScriptsKeys.all, 'detail'] as const,
};

export function useProviderCustomScriptsSettings(enabled = true) {
  return useQuery<ProviderCustomScriptsSettings, ProviderCustomScriptsRequestError>({
    queryKey: providerCustomScriptsKeys.detail(),
    queryFn: () => providerCustomScriptsService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderCustomScriptsSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    ProviderCustomScriptsSettings,
    ProviderCustomScriptsRequestError,
    UpdateProviderCustomScriptsInput
  >({
    mutationFn: (input) => providerCustomScriptsService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerCustomScriptsKeys.detail(), settings);
    },
  });
}
